import { useCallback, useEffect, useRef } from 'react';
import { getDefaultOffset, useRefGetter, useUpdate } from '@bydesign-ui/hooks';
import { useDrag } from '../../../hooks/drag';
import { usePoint } from './usePoint';
export function useDragger(elem, name, draggable) {
  var update = useUpdate();
  var point = usePoint(name);
  var region = point.getRegion();
  var value = point.getPointValue();
  var offset = point.getOffset();
  var selected = region.isValueSelected(value);
  var startOffsetRef = useRef(getDefaultOffset());
  var offsetGetter = useRefGetter(offset);
  var onDragStart = useCallback(function () {
    startOffsetRef.current = offsetGetter();
    point.setDragging(true);
  }, []);
  var onDragging = useCallback(function (e) {
    var deltaX = e.currentMousePos.clientX - e.startMousePos.clientX;
    var deltaY = e.currentMousePos.clientY - e.startMousePos.clientY;
    var x = deltaX + startOffsetRef.current.x;
    var y = deltaY + startOffsetRef.current.y;
    point.updateRealOffset(startOffsetRef.current, {
      x: x,
      y: y
    });
  }, []);
  var onDragEnd = useCallback(function (e) {
    var deltaX = e.currentMousePos.clientX - e.startMousePos.clientX;
    var deltaY = e.currentMousePos.clientY - e.startMousePos.clientY;
    var x = deltaX + startOffsetRef.current.x;
    var y = deltaY + startOffsetRef.current.y;
    point.setDragging(false);
    point.updateRealOffset(startOffsetRef.current, {
      x: x,
      y: y
    });
    startOffsetRef.current = getDefaultOffset();
  }, []);
  useDrag(elem, {
    draggable: draggable,
    data: null,
    onDragEnd: onDragEnd,
    onDragging: onDragging,
    onDragStart: onDragStart
  });
  useEffect(function () {
    point.addListener('repaint', update);
    return function () {
      return point.removeListener('repaint', update);
    };
  }, [point]);
  return {
    offset: offset,
    selected: selected,
    precision: point.getOffsetPrecisionValue(),
    dragging: point.getDragging()
  };
}